export const appleStoreLink =
  'https://apps.apple.com/ru/app/%D0%BF%D0%BE%D0%B4%D0%B0%D1%80%D0%BE%D1%87%D0%B5%D0%BA-%D1%81%D0%BA%D0%B8%D0%B4%D0%BA%D0%B8-%D0%B8-%D0%B0%D0%BA%D1%86%D0%B8%D0%B8/id1629652189';
export const googlePlayLink =
  'https://play.google.com/store/apps/details?id=com.podarochek';

export const supportHref = 'mailto:support@podarocheck.ru';
